function Logo({ size = 'md', className = '' }) {
  const sizes = {
    sm: { container: 'w-8 h-8' },
    md: { container: 'w-10 h-10' },
    lg: { container: 'w-16 h-16' },
    xl: { container: 'w-24 h-24' }
  };

  const sizeClasses = sizes[size] || sizes.md;

  return (
    <div className={`relative ${sizeClasses.container} ${className}`}>
      <img
        src="/logo.jpg"
        alt="Expense Flow for Small Biz Logo"
        className="w-full h-full object-contain rounded-lg"
      />
    </div>
  );
}

export default Logo;